module.exports = __webpack_public_path__ + "img/ky.a92b7300.svg";